export default __webpack_public_path__ + "static/INDUSTRIAL LAMINATES-a41a841ec284df600e92377d7f7970cb.webp";